export default __webpack_public_path__ + "static/media/jordan_6.234fbefb.png";